import FleetLoadConfirmationTypes from './types';

export const fetchFleetLoadConfirmationDetailStart = (payload: any) => ({
  type: FleetLoadConfirmationTypes.FETCH_FLEET_LOAD_CONFIRMATION_DETAILS_START,
  payload: payload,
});

export const fetchFleetLoadConfirmationDetailSuccess = (payload: any) => ({
  type: FleetLoadConfirmationTypes.FETCH_FLEET_LOAD_CONFIRMATION_DETAILS_SUCCESS,
  payload: payload,
});

export const fetchFleetLoadConfirmationDetailfailure = (errorMessage: any) => ({
  type: FleetLoadConfirmationTypes.FETCH_FLEET_LOAD_CONFIRMATION_DETAILS_FAILURE,
  payload: errorMessage,
});

export const initiateFleetLoadConfirmationStart = (payload: any) => ({
  type: FleetLoadConfirmationTypes.INITIATE_FLEET_LOAD_CONFIRMATION_PAYMENT_START,
  payload: payload,
});

export const initiateFleetLoadConfirmationSuccess = (payload: any) => ({
  type: FleetLoadConfirmationTypes.INITIATE_FLEET_LOAD_CONFIRMATION_PAYMENT_SUCCESS,
  payload: payload,
});

export const initiateFleetLoadConfirmationFailure = (payload: any) => ({
  type: FleetLoadConfirmationTypes.INITIATE_FLEET_LOAD_CONFIRMATION_PAYMENT_FAILURE,
  payload: payload,
});

export const initiatePaymentStatusStart = (payload: any) => ({
  type: FleetLoadConfirmationTypes.INITIATE_PAYMENT_STATUS_START,
  payload: payload,
});

export const initiatePaymentStatusSuccess = (payload: any) => ({
  type: FleetLoadConfirmationTypes.INITIATE_PAYMENT_STATUS_SUCCESS,
  payload: payload,
});

export const initiatePaymentStatusFailure = (payload: any) => ({
  type: FleetLoadConfirmationTypes.INITIATE_PAYMENT_STATUS_FAILURE,
  payload: payload,
});

export const getTokenDetailsStart = (payload: any) => ({
  type: FleetLoadConfirmationTypes.TOKEN_DETAIL,
  payload: payload,
});
export const getTokenDetailsSuccess = (payload: any) => ({
  type: FleetLoadConfirmationTypes.TOKEN_DETAIL_SUCCESS,
  payload: payload,
});
export const getTokenDetailsFailure = (payload: any) => ({
  type: FleetLoadConfirmationTypes.TOKEN_DETAIL_FAILURE,
  payload: payload,
});
export const resetTokenDetails = () => ({
  type: FleetLoadConfirmationTypes.RESET_TOKEN_DETAIL,
});
export const getWalletBalanceStart = () => ({
  type: FleetLoadConfirmationTypes.GET_BALANCE,
});
export const getWalletBalanceSuccess = (payload: any) => ({
  type: FleetLoadConfirmationTypes.GET_BALANCE_SUCCESS,
  payload: payload,
});
export const getWalletBalanceFailure = () => ({
  type: FleetLoadConfirmationTypes.GET_BALANCE_FAILURE,
});

export const confirmDemand = (payload: any) => ({
  type: FleetLoadConfirmationTypes.CONFIRM_DEMAND,
  payload: payload,
});
export const confirmDemandSuccess = (payload: any) => ({
  type: FleetLoadConfirmationTypes.CONFIRM_DEMAND_SUCCESS,
  payload: payload,
});
export const confirmDemandFailure = (payload: any) => ({
  type: FleetLoadConfirmationTypes.CONFIRM_DEMAND_FAILURE,
  payload: payload,
});

export const fetchContactInfo = (demandId: string) => ({
  type: FleetLoadConfirmationTypes.FETCH_CONTACT_INFO,
  payload: demandId,
});
export const fetchContactInfoSuccess = (payload: any) => ({
  type: FleetLoadConfirmationTypes.FETCH_CONTACT_INFO_SUCCESS,
  payload: payload,
});
export const fetchContactInfoFailure = (payload: any) => ({
  type: FleetLoadConfirmationTypes.FETCH_CONTACT_INFO_FAILURE,
  payload: payload,
});
export const postCompletePayment = (payload: any) => ({
  type: FleetLoadConfirmationTypes.POST_COMPLETE_PAYMENT,
  payload: payload,
});
export const postCompletePaymentSuccess = (payload: any) => ({
  type: FleetLoadConfirmationTypes.POST_COMPLETE_PAYMENT_SUCCESS,
  payload: payload,
});
export const postCompletePaymentFailure = (payload: any) => ({
  type: FleetLoadConfirmationTypes.POST_COMPLETE_PAYMENT_FAILURE,
  payload: payload,
});

export const getAppConfig = () => ({
  type: FleetLoadConfirmationTypes.MP_APP_CONFIG,
});
export const getAppConfigSuccess = (payload: any) => ({
  type: FleetLoadConfirmationTypes.MP_APP_CONFIG_SUCCESS,
  payload: payload,
});
export const getAppConfigFailure = (payload: any) => ({
  type: FleetLoadConfirmationTypes.MP_APP_CONFIG_FAILURE,
  payload: payload,
});

export const payTokenAmountStart = (payload: any) => ({
  type: FleetLoadConfirmationTypes.PAY_TOKEN,
  payload: payload,
});
export const payTokenAmountSuccess = (payload: any) => ({
  type: FleetLoadConfirmationTypes.PAY_TOKEN_SUCCESS,
  payload,
});
export const payTokenAmountFailure = (payload: any) => ({
  type: FleetLoadConfirmationTypes.PAY_TOKEN_FAILURE,
  payload: payload,
});

export const getVehicleNumberDetailStart = (payload: any) => ({
  type: FleetLoadConfirmationTypes.GET_VEHICLE_NUMBER_DETAIL_START,
  payload: payload,
});

export const getVehicleNumberDetailSuccess = (payload: any) => ({
  type: FleetLoadConfirmationTypes.GET_VEHICLE_NUMBER_DETAIL_SUCCESS,
  payload: payload,
});

export const getVehicleNumberDetailFailure = (payload: any) => ({
  type: FleetLoadConfirmationTypes.GET_VEHICLE_NUMBER_DETAIL_FAILURE,
  payload: payload,
});

export const getVehicleKycDetailStart = (payload: any) => ({
  type: FleetLoadConfirmationTypes.GET_VEHICLE_KYC_DETAIL_START,
  payload: payload,
});

export const getVehicleKycDetailSuccess = (payload: any) => ({
  type: FleetLoadConfirmationTypes.GET_VEHICLE_KYC_DETAIL_SUCCESS,
  payload: payload,
});

export const getVehicleKycDetailFailure = (payload: any) => ({
  type: FleetLoadConfirmationTypes.GET_VEHICLE_KYC_DETAIL_FAILURE,
  payload: payload,
});
export const getVehicleKycDetailReset = () => ({
  type: FleetLoadConfirmationTypes.RESET_VEHICLE_KYC_DETAIL,
});
